/**
 * @module components\ghTabsPage
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Model, Watch, Prop } from "vue-property-decorator";

@Component
export default class GhTabsPage extends Vue {
  @Model("update:activatedTab")
  private value!: number;
  @Prop({ default: () => [{ title: "数据维护" }, { title: "查看详情" }] })
  private tabs!: IGhTab[];

  @Prop({ default: undefined })
  private showTabs!: any;

  private activatedTab = 0;

  private get paddingTop() {
    if (this.showTabs) {
      return "48px";
    }
    return "0px";
  }

  // @Watch("activatedTab")
  // private switchTabs(from, to) {}

  @Watch("activatedTab")
  private syncActivatedTab(to, from) {
    this.$emit("update:activatedTab", this.activatedTab);
    if (this.tabs[from]) {
      let tab = this.tabs[from];
      tab.preMini = tab.mini;
      tab.preDrawer = tab.drawer;
      this.tabs[from].drawer = false;
    }
    if (this.tabs[to]) {
      let tab = this.tabs[to];
      if (tab.preDrawer) {
        tab.drawer = tab.preDrawer;
      }
      if (tab.preMini) {
        tab.mini = tab.preMini;
      }
    }
  }
  @Watch("value")
  private syncValue() {
    if (this.value !== this.activatedTab) {
      this.activatedTab = this.value;
    }
  }

  private returnPre() {
    if (this.activatedTab > 0) {
      this.activatedTab = this.activatedTab - 1;
    }
  }
}
